import { useRef, useState } from 'react'
import { API_ROUTES, clearFlashMessages, DEVICES_LIST, setFlashMessage, TRANS_SS_MODES, userIsLogged } from '../../helpers'

import $ from 'jquery';
import House from './House';

const listHours = Array(24).fill(0).map((val, index) => {
    if (index < 10) {
        index = "0" + index
    }
    return <option value={index}>{index}</option>
})
const listMinutes = Array(6).fill(0).map((val, index) => {
    let value = index === 0 ? 0 : index * 10
    if (value < 10) {
        value = "0" + value
    }
    return <option value={value} >{value}</option>
})

const listTemperatures = Array(15).fill(0).map((val, index) => {
    let value = index + 16
    let valueMid = value + 0.5
    return (<><option value={value} >{value}</option> <option value={valueMid} >{valueMid}</option></>)
})

function getDateDayName(day) {
    return ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"][day]
}

const listDays = Array(7).fill(0).map((val, index) => {
    let dt = new Date()
    dt.setDate(dt.getDate() + index)
    let day = getDateDayName(dt.getDay())
    if (index === 0) {
        day = "Aujourd'hui"
    }
    if (index === 1) {
        day = "Demain"
    }

    const currentDtStr = day + ' ' + dt.getDate() + '/' + (dt.getMonth() + 1)
    if (index === 0) {
        return (<option value="today">{currentDtStr}</option>)
    }
    return (<option value={"today + " + index + " days"}>{currentDtStr}</option>)
})

export class HouseProgManagement {

    requestSaveProgrammation(deviceName, progDay, progTimeHours, progTimeMinutes, progTargetTemp, isProgRepeatDaily = false) {
        const payload = { deviceName, progDay, progTimeHours, progTimeMinutes, progTargetTemp, isProgRepeatDaily }
        $.post(API_ROUTES.PROG_SAVE, payload, (data) => {
            this.loadProgsIntoTemplate()
        }
        ).fail(error => {
            let msg = 'Echec de la création de la programmation';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
        });
    }

    cancelDeviceProg(progId) {
        $.post(API_ROUTES.PROG_CANCEL, { 'progId': progId }, (data) => {
            this.loadProgsIntoTemplate()
        }
        ).fail(error => {
            let msg = 'Echec de l\'annulation de la programmation';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
        });
    }

    saveProg() {
        const progTargetTemp = this.programDeviceName === 'O_SS' ? this.programTempSS : this.programTemp
        this.requestSaveProgrammation(this.programDeviceName, this.programDateDay, this.programDateHours, this.programDateMinutes, progTargetTemp, this.programIsRepeatDaily)
    }

    setDeviceProgEnable(progId, enable) {
        $.post(API_ROUTES.PROG_DISABLE_ENABLE, { progId, enable }, (data) => {
            this.loadProgsIntoTemplate()
        }
        ).fail(error => {
            let msg = 'Echec de la désactivation/activation de la programmation';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
        });
    }


    getProgsItemsToDisplay() {
        if (this._progs) {
            return this._progs.map(item => {
                if (this._displayOnlyRepeated === true && item.repeatDaily === false) {
                    return
                }
                return (
                    <tr className={(item.enabled !== true ? 'table-line-disabled' : '')}>
                        <td>{DEVICES_LIST.find(o => o.name === item.operationIdentifier).label}</td>
                        <td>{item.dateTriggerLocal}
                            <div className={(item.repeatDaily !== true ? 'd-none' : '')}>
                                <i className="fa fa-repeat fa-lg"><br /></i>
                            </div>
                        </td>
                        <td>{item.operationIdentifier === 'O_SS' ? TRANS_SS_MODES[item.operationValue] : item.operationValue}</td>
                        <td>{item.repeatDaily === true ? 'Oui' : 'Non'}</td>
                        <td><button className='btn btn-danger' onClick={() => this.cancelDeviceProg(item.id)}>Annuler</button>
                            <button className={'ml-2 btn btn-warning ' + (item.enabled === false ? 'd-none' : '')} onClick={() => this.setDeviceProgEnable(item.id, false)}>Désactiver</button>
                            <button className={'ml-2 btn btn-warning ' + (item.enabled === true ? 'd-none' : '')} onClick={() => this.setDeviceProgEnable(item.id, true)}>Activer</button>
                        </td>
                    </tr >
                )
            })
        }

    }

    async loadProgs() {
        return new Promise((resolve, reject) => {
            let url = API_ROUTES.DEVICES_GET_PROGS
            $.get(url, (data) => {
                resolve(data)
                if ($('#flashMessages div').first().text().includes('Echec du chargement des données')) {
                    clearFlashMessages()
                }
            }
            ).fail(error => {
                let msg = 'Echec du chargement des données de programmes (PROG)';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve()
            }).always(() => {
            });
        })
    }

    loadProgsIntoTemplate() {
        this.loadProgs().then((data) => {
            if (data) {
                if (JSON.stringify(this._progs) === JSON.stringify(data)) {
                    return
                }
                this._setProgs(data)
            }
        })
    }


}

export default function HouseProg() {

    const [isLogged, setIsLogged] = useState(false)
    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                window.location.href = process.env.REACT_APP_HOST + '/common/login'
            }
            setIsLogged(isLogged)
        })
    }


    const listDevices = DEVICES_LIST.map((device) => {
        return (<option value={device.name} >{device.label}</option>)
    })


    const SSModeOptions = Object.keys(TRANS_SS_MODES).map((key) => {
        return <option value={key} key={key}>{TRANS_SS_MODES[key]}</option>
    })



    const REFRESH_INTERVAL = 30 * 1000
    let refRefreshIntervalId = useRef(null)

    const manager = new HouseProgManagement()

    const [progs, setProgs] = useState(null)
    const [currentDeviceNameSelected, setCurrentDeviceNameSelected] = useState('R_SALON')
    const [displayOnlyRepeated, setDisplayOnlyRepeated] = useState(false)
    const [isProgRepeatDaily, setIsProgRepeatDaily] = useState(false)
    const [programTemp, setProgramTemp] = useState("STOP")
    const [programDateDay, setProgramDateDay] = useState("today")
    const [programDateHours, setProgramDateHours] = useState("00")
    const [programDateMinutes, setProgramDateMinutes] = useState("00")
    const [programTempSS, setProgramTempSS] = useState("frostprotection")

    manager._progs = progs
    manager._setProgs = setProgs
    manager._displayOnlyRepeated = displayOnlyRepeated

    manager.programTemp = programTemp
    manager.programDateDay = programDateDay
    manager.programDateHours = programDateHours
    manager.programDateMinutes = programDateMinutes
    manager.programIsRepeatDaily = isProgRepeatDaily
    manager.programDeviceName = currentDeviceNameSelected
    manager.programTempSS = programTempSS

    if (progs === null) {
        manager.loadProgsIntoTemplate()
    }

    if (refRefreshIntervalId?.current === null) {
        refRefreshIntervalId.current = setInterval(() => {
            manager.loadProgsIntoTemplate()
        }, REFRESH_INTERVAL)
    }

    if (isLogged) {
        return (
            <>
                <House activeTab="prog" />
                <div className="conteneur">
                    <div id="flashMessages"></div>
                    <div id="devicesProgPart">
                        <div className="text-center">
                            <h4><i className="fa fa-user-clock small"></i> Programmation</h4>
                            <br />
                        </div>

                        <div className="row text-center mt-3">
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <i className="fa fa-home"></i>
                                <select className="form-control w-75 d-inline-block" id="program_deviceName" defaultValue={currentDeviceNameSelected} onChange={(e) => { setCurrentDeviceNameSelected(e.target.value) }}>
                                    {listDevices}
                                </select>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4 mb-3">
                                <i className="fa fa-thermometer-2"></i>
                                <select className={'form-control w-75 ' + (currentDeviceNameSelected === 'O_SS' ? 'd-none' : 'd-inline-block')} id="program_temp" defaultValue={manager.programTemp} onChange={(e) => { setProgramTemp(e.target.value) }}>
                                    <option value="STOP">ARRET</option>
                                    {listTemperatures}
                                </select>
                                <select className={'form-control w-75 ' + (currentDeviceNameSelected === 'O_SS' ? 'd-inline-block' : 'd-none')} id="program_ss_temp" defaultValue={manager.programTempSS} onChange={(e) => { setProgramTempSS(e.target.value) }}>
                                    {SSModeOptions}
                                </select>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 mb-3">
                                <i className="fa fa-calendar"></i>
                                <select className="form-control w-25 d-inline-block" id="program_date_day" defaultValue={manager.programDateDay} onChange={(e) => { setProgramDateDay(e.target.value) }}>
                                    {listDays}
                                </select>
                                <i className="fa fa-clock-o"></i>
                                <select className="form-control w-25 d-inline-block" id="program_date_time_hours" defaultValue={manager.programDateHours} onChange={(e) => { setProgramDateHours(e.target.value) }}>
                                    {listHours}
                                </select>
                                H
                                <select className="form-control w-25 d-inline-block" id="program_date_time_minutes" defaultValue={manager.programDateMinutes} onChange={(e) => { setProgramDateMinutes(e.target.value) }}>
                                    {listMinutes}
                                </select>

                                <label className="checkbox-inline">
                                    <input type="checkbox" id="program_repeat_daily" className="form-check-input" defaultValue={manager.programIsRepeatDaily} onChange={(e) => { setIsProgRepeatDaily(!manager.programIsRepeatDaily) }} /> Répéter tous les jours
                                </label>


                            </div>
                            <div className="col-12 text-center">
                                <button className="btn btn-primary" onClick={() => manager.saveProg()}>Programmer</button>
                            </div>
                        </div>

                        <div className="mt-2 text-center" id="histoProg">
                            <h4><i className="fa fa-clock-four small"></i> En attente d'éxécution </h4>
                            <br />
                            <label className="checkbox-inline">
                                <input type="checkbox" id="histoProg_displayRepeated" className="form-check-input" onClick={() => { setDisplayOnlyRepeated(!displayOnlyRepeated) }} /> Afficher les programmations récurrentes (tous les jours)
                            </label>

                            <table className="table table-bordered">
                                <thead>
                                    <th>Device</th>
                                    <th>Date</th>
                                    <th>Temp. cible</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {manager.getProgsItemsToDisplay(progs)}
                                </tbody>
                            </table>
                        </div>

                        <div className="text-center small">
                            <img onClick={() => { manager.loadProgsIntoTemplate() }} src={require('../../resources/img/refresh.png')} className="cursor-pointer"
                                style={{ width: "24px" }} alt="Forcer à rafraichir" />
                        </div>

                    </div>
                </div>

            </>)
    }
}
